/**
 * @copyright Elmelo Ltd.
 */

import React from "react";

import { useSelector, useDispatch, } from "react-redux";

import { ICartOpt } from "../_types/cart";

import {CartCalcAsync} from './cart.slice'

interface IRdxWrapper
{
  children: any,
}

export const RdxWrapper = ( props: IRdxWrapper ) =>
{
  const dispatch = useDispatch();

  const rdxCartItems: ICartOpt[] = useSelector( (state: any) => state.__cart.items )
  const rdxCheckout = useSelector((state: any) => state.__checkout);
  const rdxCoreMenu: any[] = useSelector((state: any) => state.__core.menu.menu);

  /**
   */
  React.useEffect( () => {
    // the persisted cart is restored before the menu loads; wait for the menu,
    // otherwise the subtotal is calculated as 0 and never recalculated
    if( !rdxCoreMenu || !rdxCoreMenu.length )
    {
      return
    }

    // calculates total when any change occurs
    dispatch( CartCalcAsync( rdxCartItems ) )
  }, [rdxCartItems, rdxCheckout.delivery.deliveryType, rdxCoreMenu] )

  /**
   */
  return (
    <>
    {
      props.children
    }
    </>
  )
}

